/* @flow */
import axios from 'axios';
import API from 'lib/RemindAPI';
import FileEntity from 'entities/File';
import * as actions from 'reducers/fileUploads';

function buildForm(postParams: Object, blob: File) {
  const form = new FormData();
  // $FlowIssue - Object.entries returns [string, mixed] array but fields are always strings
  const entries: [string, string][] = Object.entries(postParams.fields);
  entries.forEach(pair => form.append(...pair));
  form.append('file', blob);
  return form;
}

export async function uploadFileRequest(
  fileContextKey: string,
  fileKey: Backbone$Id,
  blob: File,
  privateUpload: boolean = false
): Promise<FileEntity> {
  // Fetch file upload address and fields from api
  const fileName = blob.name;
  const postParamsPromise = API.request('/files', 'POST', {
    file: {
      name: fileName,
    },
    private: privateUpload,
  });

  const postParams = await postParamsPromise;
  const uploadUrl = postParams.upload_url;

  // Upload file to CDN
  await axios.post(uploadUrl, buildForm(postParams, blob), {
    onUploadProgress: progressEvent => {
      const progressPercentage = (progressEvent.loaded / progressEvent.total) * 100;
      actions.progressUpdate(fileContextKey, fileKey, progressPercentage);
    },
  });

  // Load file entity
  const fileId = postParams.id;
  const url = `${uploadUrl}/${fileId}/${fileName}`;
  return FileEntity.fromJSON({
    id: fileId,
    content_type: blob.type,
    size: blob.size,
    name: fileName,
    urls: {
      cdn: url,
    },
  });
}

export async function fetchFileByIdRequest(fileId: Backbone$Id): Promise<FileEntity> {
  const fileResponse = await API.request(`/files/${fileId}`, 'GET');
  return FileEntity.fromJSON(fileResponse);
}
